export default function Loader() {
  return (
    <div style={styles.wrapper}>
      <div style={styles.spinner}></div>
    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "30px 0",
  },
  spinner: {
    width: "38px",
    height: "38px",
    border: "4px solid rgba(255,255,255,0.15)",
    borderTopColor: "#19F5BE", // Neon green highlight
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
};
